import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Snackbar,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  QuestionAnswer,
  ExpandMore,
  ExpandLess,
  PlayArrow,
  Lock,
  PlayCircleFilled,
  Bookmark,
  BookmarkBorder,
  KeyboardArrowDown
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import DaySelector from "../Extra/DayChanger";
import { ReactComponent as LockIcon } from "../../assets/lock1.svg";
import {
  getCurrentUserAllTrainings,
  getCurrentUserLevels,
  getCurrentUserMasterclassTrainings, // ADD THIS IMPORT
  getCurrentUserTrainings,
  updateMasterclassTrainingById,
  updateSelectedLevel,
  updateTrainingById,
  updateTrainingProgressById
} from "../../features/training/trainingSlice";
import {
  selectAllMasterclassTrainings, // ADD THIS IMPORT
  selectAllTrainingsData,
  selectAllTrainingsWithTitleData,
  selectLevel,
  selectLevelData,
  selectMasterclassError // ADD THIS IMPORT
} from "../../features/training/trainingSelectors";
import CircularProgressStatic from "../Extra/ProgressTracker";
import RenderHtml from "../Extra/RenderHtml/RenderHtml";
import dayjs from "dayjs";
import { selectCurrentUser } from "../../features/auth/authSelectors";
import useThemeColor from "../../utils/useTheme";
import {
  purchaseTraining,
  updateMasterclassTrainingProgress,
  updateTrainingProgress
} from "../../api/trainingApi";
import useIsMobile from "../Extra/useMobile";
import utc from "dayjs/plugin/utc";
import SubscriptionModal from "../Modals/SubscriptionModal";
import {
  allowedCountries,
  countryRates
} from "../../utils/countryRatesMapping";
import { fetchCurrentUser } from "../../features/auth/authSlice";
dayjs.extend(utc);

const MobileLevelsDropdown = ({
  allLevels,
  selectedLevel,
  setSelectedLevel,
  setActiveLevelForMobile,
  setActiveDay,
  setStartDay,
  visibleDaysCount,
  masterclassData,
  showMasterclass,
  setSnackbarMessage,
  setOpenSnackbar,
  userData
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const styles = useThemeColor();
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLevelClick = (
    levelName,
    levelActive,
    isMasterclassLevel = false
  ) => {
    if (levelActive) {
      setSelectedLevel(levelName);
      setActiveDay(1);
      setStartDay(1);
      setActiveLevelForMobile(true);
      localStorage.setItem(
        "lastProgramVisitedLevel",
        JSON.stringify({
          level: levelName,
          activeDay: 1
        })
      );
      dispatch(updateSelectedLevel(levelName));
      window.scrollTo(0, 0);
      const scrollableElement = document.getElementById("dashboard-main");
      scrollableElement?.scrollTo(0, 0);

      // Refetch data for the new level
      dispatch(getCurrentUserLevels(dayjs().format("YYYY-MM-DD")));
      dispatch(fetchCurrentUser(dayjs().format("YYYY-MM-DD")));
      const levelData = allLevels?.find(
        (level) => level.levelName === levelName
      );
      if (levelData?.levelId && !isMasterclassLevel) {
        dispatch(getCurrentUserTrainings(levelData.levelId));
      } else if (isMasterclassLevel) {
        dispatch(
          getCurrentUserMasterclassTrainings(dayjs().format("YYYY-MM-DD"))
        );
      }
    } else {
      if (!isMasterclassLevel) {
        setSnackbarMessage(
          "Please purchase the corresponding Training Program to unlock"
        );
        setOpenSnackbar(true);
      }
    }
    handleClose();
  };

  // Determine current level display
  const getCurrentLevelDisplay = () => {
    if (showMasterclass && masterclassData?.trainings?.[selectedLevel]) {
      if (selectedLevel === "Overview") {
        return `Overview`;
      } else if (selectedLevel === "10Principles") {
        return "10 Principles";
      } else if (selectedLevel === "CoachesVault") {
        return "Coaches Vault";
      }
    }
    const currentLevel = allLevels?.find(
      (level) => level.levelName === selectedLevel
    );
    return currentLevel?.title || "Program";
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flex: 1
      }}
    >
      <Button
        onClick={handleClick}
        size="small"
        variant="outlined"
        endIcon={<KeyboardArrowDown sx={{ width: 16, height: 16 }} />}
        aria-controls={open ? "levels-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{
          borderRadius: "8px",
          minWidth: "120px",
          height: "36px",
          padding: "0px 12px",
          borderColor: "rgba(255, 255, 255, 0.2)",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderColor: "rgba(255, 255, 255, 0.3)"
          },
          color: styles.color,
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)"
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            textTransform: "none",
            letterSpacing: "0.4px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "160px"
          }}
        >
          {getCurrentLevelDisplay()}
        </Typography>
      </Button>

      <Menu
        id="levels-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "dropdown-button",
          dense: true,
          sx: {
            py: 0.5,
            minWidth: "200px",
            bgcolor: styles.background || "rgba(18, 18, 18, 0.95)"
          }
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: "10px",
            mt: 0.5,
            border: "1px solid rgba(255, 255, 255, 0.1)",
            overflow: "hidden"
          }
        }}
      >
        {/* Masterclass levels */}
        {showMasterclass &&
          masterclassData?.trainings &&
          Object.entries(masterclassData.trainings).map(
            ([sectionType, trainings]) => {
              const isLocked =
                sectionType === "CoachesVault" &&
                masterclassData?.trainings?.["CoachesVault"]?.filter(
                  (training) => training?.isUnlocked
                )?.length <= 0;

              const displayName =
                sectionType === "Overview"
                  ? `Overview`
                  : sectionType === "10Principles"
                    ? "10 Principles of Nutrition"
                    : "Coaches Vault";

              return (
                <MenuItem
                  key={`masterclass-${sectionType}`}
                  onClick={() => handleLevelClick(sectionType, !isLocked, true)}
                  selected={selectedLevel === sectionType}
                  disabled={isLocked}
                  sx={{
                    py: 1,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    border: 0,
                    color: styles.color,
                    minHeight: "36px",
                    justifyContent: "space-between",
                    borderRadius: "4px",
                    "&.Mui-selected": {
                      backgroundColor: "rgba(100, 174, 221, 0.15)",
                      "&:hover": {
                        backgroundColor: "rgba(100, 174, 221, 0.25)"
                      }
                    },
                    "&:hover": {
                      backgroundColor: !isLocked
                        ? "rgba(255, 255, 255, 0.05)"
                        : "transparent"
                    }
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: selectedLevel === sectionType ? 600 : 500,
                        color: styles.color
                      }}
                    >
                      {displayName}
                    </Typography>
                  </Box>
                  {isLocked && (
                    <LockIcon
                      style={{
                        width: 18,
                        height: 18,
                        marginLeft: 10
                      }}
                    />
                  )}
                </MenuItem>
              );
            }
          )}

        {/* Regular training levels */}
        {allLevels?.map(({ title, levelName, levelActive }) => {
          const isUnlocked =
            levelActive ||
            userData?.purchased_training_by_admin?.includes(levelName);
          return (
            <MenuItem
              key={levelName}
              onClick={() => handleLevelClick(levelName, isUnlocked, false)}
              selected={selectedLevel === levelName}
              disabled={!isUnlocked}
              sx={{
                py: 1,
                px: 2,
                display: "flex",
                alignItems: "center",
                border: 0,
                color: styles.color,
                minHeight: "36px",
                justifyContent: "space-between",
                borderRadius: "4px",
                "&.Mui-selected": {
                  backgroundColor: "rgba(100, 174, 221, 0.15)",
                  "&:hover": {
                    backgroundColor: "rgba(100, 174, 221, 0.25)"
                  }
                },
                "&:hover": {
                  backgroundColor: isUnlocked
                    ? "rgba(255, 255, 255, 0.05)"
                    : "transparent"
                }
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: selectedLevel === levelName ? 600 : 500,
                    color: styles.color
                  }}
                >
                  {title}
                </Typography>
              </Box>
              {!isUnlocked && (
                <LockIcon
                  style={{
                    width: 18,
                    height: 18,
                    marginLeft: 10
                  }}
                />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

const Programs = ({
  open,
  activeLevelForMobile,
  setOpenSubscriptionModal,
  setActiveLevelForMobile
}) => {
  const [selectedLevel, setSelectedLevel] = React.useState("");
  const dispatch = useDispatch();
  const styles = useThemeColor();
  const allLevels = useSelector(selectLevelData);
  const theme = useTheme();
  const isInMobile = useIsMobile();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")) || isInMobile;
  const trainingData = useSelector(selectAllTrainingsData);
  const trainingWithTitleData = useSelector(selectAllTrainingsWithTitleData);
  const masterclassData = useSelector(selectAllMasterclassTrainings);
  const masterclassError = useSelector(selectMasterclassError);
  const [activeDay, setActiveDay] = useState(0);
  const [tocDay, setTocDay] = useState(0);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const userData = useSelector(selectCurrentUser);
  const [isAudioFinished, setIsAudioFinished] = useState(false);
  const [expandedLevels, setExpandedLevels] = useState({});
  const [tocOpen, setTocOpen] = useState(false);
  const reduxLevel = useSelector(selectLevel);
  // Add this function to handle expand/collapse
  const toggleLevelExpansion = (levelName) => {
    setExpandedLevels((prev) => ({
      ...prev,
      [levelName]: !prev[levelName]
    }));
  };
  const handleLevelSelect = (level) => {
    setSelectedLevel(level);
    setActiveLevelForMobile(true);
  };
  const currentLevel = useMemo(() => {
    return allLevels?.find((item) => item?.levelName === selectedLevel);
  }, [allLevels, selectedLevel]);
  useEffect(() => {
    const existingData = JSON.parse(
      localStorage.getItem("lastProgramVisitedLevel") || "{}"
    );

    if (existingData?.level) {
      setSelectedLevel(existingData.level);
    }

    // Set activeDay from localStorage if it exists
    if (existingData?.activeDay) {
      setActiveDay(existingData.activeDay);
    }
  }, []);
  const showMasterclass = useMemo(() => userData?.masterclassData, [userData]); // Use user?.masterclassId;
  useEffect(() => {
    dispatch(getCurrentUserLevels(dayjs().format("YYYY-MM-DD")));
    dispatch(getCurrentUserAllTrainings(dayjs().format("YYYY-MM-DD")));
    dispatch(fetchCurrentUser(dayjs().format("YYYY-MM-DD")));
  }, [dispatch]);
  useEffect(() => {
    if (showMasterclass) {
      dispatch(
        getCurrentUserMasterclassTrainings(dayjs().format("YYYY-MM-DD"))
      );
    }
  }, [showMasterclass, dispatch]);
  const { startDate, endDate } = showMasterclass || {};
  const now = dayjs.utc();
  const isBetween =
    now.isAfter(dayjs.utc(startDate).subtract(1, "day")) &&
    now.isBefore(dayjs.utc(endDate).add(1, "day"));
  const link = useMemo(() => {
    return showMasterclass &&
      isBetween &&
      !(userData?.userType === "Coach" && userData?.isAdmin)
      ? showMasterclass?.link?.[currentLevel?.levelName]
      : currentLevel?.link;
  }, [currentLevel, showMasterclass]);

  useEffect(() => {
    if (currentLevel?.levelId)
      dispatch(getCurrentUserTrainings(currentLevel?.levelId));
  }, [dispatch, currentLevel?.levelId]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    const scrollableElement = document.getElementById("dashboard-main");
    scrollableElement.scrollTo(0, 0);
    localStorage.setItem("lastVisitedRoute", "/programs");
  }, []);
  const masterclassTrainingData = useMemo(() => {
    if (!showMasterclass || !masterclassData?.trainings || !selectedLevel)
      return [];
    return masterclassData.trainings[selectedLevel] || [];
  }, [showMasterclass, masterclassData, selectedLevel]);

  const [isTrainingUpdated, setIsTrainingUpdated] = useState(false);
  // Determine which training data to use based on selection
  const currentTrainingData = useMemo(() => {
    if (
      showMasterclass &&
      !selectedLevel?.includes("level") &&
      !isTrainingUpdated &&
      masterclassData?.trainings?.[selectedLevel]
    ) {
      return masterclassTrainingData;
    }
    return trainingData;
  }, [
    showMasterclass,
    selectedLevel,
    masterclassData,
    isTrainingUpdated,
    masterclassTrainingData,
    trainingData
  ]);
  const calculateActiveDay = useCallback(() => {
    if (!currentTrainingData || currentTrainingData.length === 0) return 0;

    const existingSelectedTrainingDay = localStorage.getItem(
      "lastProgramVisitedLevel"
    );

    if (existingSelectedTrainingDay) {
      const storedData = JSON.parse(existingSelectedTrainingDay);
      const storedActiveDay = storedData?.activeDay;
      const storedLevel = storedData?.level;

      // If we have stored data for the current level, use it
      if (storedActiveDay && storedLevel === selectedLevel) {
        const dayExists = currentTrainingData.some(
          (item) => item.day === `Day ${storedActiveDay}`
        );
        if (dayExists) {
          return storedActiveDay;
        }
      }
    }

    let activeDay = 1;
    for (let i = 0; i < currentTrainingData?.length; i++) {
      const task = currentTrainingData[i];
      const day = +task.day.split(" ")[1];
      if (showMasterclass && !selectedLevel?.includes("level")) {
        if (!task.completedOn && day && task.isUnlocked) {
          activeDay = day;
          break;
        }
      } else if (!task.completedOn && day) {
        activeDay = day;
        break;
      }
    }
    // Limit activeDay to the maximum day in enabledDays
    const maxEnabledDay =
      showMasterclass && !selectedLevel?.includes("level")
        ? activeDay
        : Math.max(
            ...(currentLevel?.trainingCompletionPercentage === 100 &&
            currentLevel?.totalTrainingDays !== 0
              ? Array.from(
                  { length: currentLevel?.completedTrainingDays },
                  (_, i) => i + 1
                )
              : !userData?.isSubscriptionNeeded
                ? Array.from(
                    {
                      length:
                        dayjs()
                          .startOf("day")
                          .diff(
                            dayjs(
                              dayjs(
                                userData?.[
                                  `${currentLevel?.levelName}_start_date`
                                ]
                              )
                                .utc()
                                .format("YYYY-MM-DD")
                            ).startOf("day"),
                            "day"
                          ) + 1
                    },
                    (_, i) => i + 1
                  )
                : !userData?.isTrainingFreeTrialExpired
                  ? Array.from(
                      {
                        length: Math.min(
                          5,
                          dayjs()
                            .startOf("day")
                            .diff(
                              dayjs(
                                dayjs(
                                  userData?.[
                                    `${currentLevel?.levelName}_start_date`
                                  ]
                                )
                                  .utc()
                                  .format("YYYY-MM-DD")
                              ).startOf("day"),
                              "day"
                            ) + 1
                        )
                      },
                      (_, i) => i + 1
                    )
                  : [])
          );
    return Math.min(activeDay, maxEnabledDay, currentTrainingData.length) || 1;
  }, [
    currentTrainingData,
    userData,
    currentLevel,
    selectedLevel,
    showMasterclass
  ]);

  const [startDay, setStartDay] = useState(1); // Start displaying from day 1
  const [openModal, setOpenModal] = useState(false);
  const [showCompletionPopup, setShowCompletionPopup] = useState(false);
  const [completionPopupData, setCompletionPopupData] = useState(null);
  const days = Array.from(
    { length: currentTrainingData?.length },
    (_, i) => i + 1
  ); // Days 1 to 30
  const visibleDaysCount = isMobile ? 5 : 8; // Number of days to show at a time
  const visibleDays = days.slice(startDay - 1, startDay - 1 + visibleDaysCount);
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const isLaptop = useMediaQuery("(min-width: 900px) and (max-width: 1300px)");

  useEffect(() => {
    if (currentTrainingData) {
      const currentDay = tocDay
        ? tocDay
        : calculateActiveDay(currentTrainingData);
      setActiveDay(currentDay);
      if (currentDay > visibleDaysCount) {
        const pageIndex = Math.floor((currentDay - 1) / visibleDaysCount);
        // Calculate startDay for that page
        const calculatedStartDay = pageIndex * visibleDaysCount + 1;
        setStartDay(calculatedStartDay);
      } else {
        setStartDay(1); // Reset to 1 if currentDay is less than or equal to visibleDaysCount
      }
    }
  }, [currentTrainingData]);

  const handleDayClick = (day) => {
    setActiveDay(day);
    setIsAudioFinished(false);

    // Always update localStorage when a day is clicked
    if (selectedLevel) {
      localStorage.setItem(
        "lastProgramVisitedLevel",
        JSON.stringify({
          level: selectedLevel,
          activeDay: day
        })
      );
    }
  };

  const currentActiveData = useMemo(() => {
    return currentTrainingData?.find((item) => item.day === `Day ${activeDay}`);
  }, [currentTrainingData, activeDay]);

  const nextActiveData = useMemo(() => {
    return currentTrainingData?.find(
      (item) => item.day === `Day ${activeDay + 1}`
    );
  }, [currentTrainingData, activeDay]);

  const allCompletedData = useMemo(() => {
    return currentTrainingData
      ?.filter((item) => item.completedOn)
      ?.map((item) => +item.day.split(" ")?.[1]);
  }, [currentTrainingData]);

  const handleNext = () => {
    if (startDay + visibleDaysCount - 1 < days.length) {
      setStartDay((prev) => prev + visibleDaysCount);
      setIsAudioFinished(false);
    }
  };

  const handlePrevious = () => {
    if (startDay > 1) {
      setStartDay((prev) => prev - visibleDaysCount);
      setIsAudioFinished(false);
    }
  };
  const isContentLocked =
    showMasterclass &&
    selectedLevel?.includes("Coaches") &&
    !currentActiveData?.isUnlocked
      ? true
      : showMasterclass && !selectedLevel?.includes("level")
        ? false
        : userData?.isTrainingFreeTrialExpired &&
          userData?.isSubscriptionNeeded &&
          currentLevel?.trainingCompletionPercentage !== 100;
  //    ||
  // currentLevel?.levelName === "level3";
  const currentCurrency = useMemo(
    () =>
      countryRates[
        allowedCountries?.includes(userData?.country) ? userData?.country : "US"
      ],
    [userData]
  );
  useEffect(() => {
    const isOverviewVisited = localStorage.getItem("isOverviewVisited");
    if (userData?.activeLevel && !isContentLocked) {
      const existingData = JSON.parse(
        localStorage.getItem("lastProgramVisitedLevel") || "{}"
      );
      if (existingData?.level && !isTrainingUpdated) {
        setSelectedLevel(reduxLevel || existingData.level);
      } else if (!isOverviewVisited && !isTrainingUpdated && showMasterclass) {
        setSelectedLevel("Overview");
        setTimeout(() => {
          localStorage.setItem("isOverviewVisited", true);
        }, 1500);
      } else if (
        showMasterclass &&
        !isTrainingUpdated &&
        showMasterclass?.type === "accelerator"
      ) {
        setSelectedLevel("Overview"); // Default for accelerator
      } else if (showMasterclass && !isTrainingUpdated) {
        setSelectedLevel("10Principles"); // Default for masterclass
      } else if (selectedLevel && isTrainingUpdated) {
        // setSelectedLevel(selectedLevel);
      } else {
        setSelectedLevel(userData.activeLevel);
      }
      setActiveLevelForMobile(true);
    }
  }, [userData, reduxLevel, isTrainingUpdated]);
  return (
    <Box
      pb={10}
      sx={{
        padding: isMobile ? "0" : "20px 0 40px 32px"
      }}
    >
      <SubscriptionModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        isMobile={isMobile}
      />
      {((!activeLevelForMobile && isMobile) || !isMobile) && (
        <Box display="flex" flexDirection={"column"}>
          <Box
            sx={{
              ...(isMobile && {
                width: "100%",
                padding: "16px",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "10px",
                color: "#FCFCFC"
              })
            }}
          >
            <Typography
              fontSize={isMobile ? "28px" : "30px"}
              fontWeight={600}
              ml={2}
              color={styles.color}
            >
              Programs
            </Typography>
            {/* <Typography
              textAlign={isMobile ? "center" : "left"}
              color="#6B7280"
              fontSize={isMobile ? "13px" : "16px"}
              fontWeight={isMobile ? 600 : 500}
            >
              Where you learn how to create your own diet plan
            </Typography> */}
          </Box>
          <Box
            mt={isMobile ? 0 : 3}
            gap={2}
            display={"flex"}
            sx={{ userSelect: "none" }}
            flexDirection={!(isTablet || isLaptop) ? "row" : "column"}
          >
            <Box
              sx={{
                width: isLaptop
                  ? "55%"
                  : isTablet
                  ? "90%"
                  : !isMobile
                  ? { md: open ? "27%" : "24%" }
                  : "100%",
                borderRadius: "24px",
                // ...(!isMobile && {
                //   height: "calc(100vh - 40px)"
                // }),
                background: styles.levelBackgrounds,
                margin: isLaptop ? "0 auto" : 2,
                display: "flex",
                flexDirection: "column",
                padding:
                  isTablet || isMobile || isLaptop
                    ? "20px"
                    : { md: "24px 11px", lg: "24px 16px" },
                overflowY: "auto",
                ...((isTablet || isLaptop) && { height: "100%" })
              }}
              gap={4}
            >
              {!masterclassError?.message &&
                showMasterclass &&
                masterclassData?.trainings &&
                Object.entries(masterclassData.trainings).map(
                  ([sectionType, trainings]) => (
                    <Box
                      key={`masterclass-${sectionType}`}
                      sx={{ width: "100%" }}
                    >
                      <Button
                        fullWidth
                        onClick={() => {
                          if (
                            sectionType === "CoachesVault" &&
                            masterclassData?.trainings?.[
                              "CoachesVault"
                            ]?.filter((training) => training?.isUnlocked)
                              ?.length <= 0
                          ) {
                            return;
                          }
                          setIsTrainingUpdated(false);
                          setSelectedLevel(sectionType);
                          setActiveLevelForMobile(true);
                        }}
                        sx={{
                          ...(sectionType === "CoachesVault" &&
                          masterclassData?.trainings?.["CoachesVault"]?.filter(
                            (training) => training?.isUnlocked
                          )?.length <= 0
                            ? {}
                            : sectionType !== "Overview" &&
                              trainings.length > 0 && {
                                paddingBottom: "0 !important",
                                paddingTop: "36px !important"
                              }),
                          padding: isMobile ? 3 : "45px 24px",
                          alignItems: "center",
                          border:
                            selectedLevel === sectionType
                              ? "1px solid #368AD0"
                              : "1px solid #D1D5DB",
                          borderRadius: "16px",
                          backgroundColor:
                            selectedLevel === sectionType
                              ? "#368AD0"
                              : "transparent"
                        }}
                      >
                        <Box
                          width="100%"
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          textTransform="none"
                        >
                          <Box
                            display="flex"
                            gap="16px"
                            justifyContent="space-between"
                            alignItems="center"
                            width="100%"
                          >
                            <Box
                              textAlign={"start"}
                              gap="4px"
                              display="flex"
                              flexDirection="column"
                              flex={1} // ADD THIS
                            >
                              <Box>
                                <Typography
                                  color={"#FCFCFC"}
                                  fontSize="0.95rem"
                                  fontWeight={600}
                                >
                                  {sectionType === "Overview"
                                    ? `${masterclassData?.title} Overview`
                                    : sectionType === "10Principles"
                                      ? "10 Principles of Nutrition"
                                      : "Coaches Vault"}
                                </Typography>
                                {sectionType === "CoachesVault" &&
                                  masterclassData?.trainings?.[
                                    "CoachesVault"
                                  ]?.filter((training) => training?.isUnlocked)
                                    ?.length <= 0 && (
                                    <Typography
                                      color={"#FCFCFC"}
                                      fontSize="0.8rem"
                                      fontWeight={500}
                                    >
                                      Unlocks on{" "}
                                      {dayjs
                                        .utc(
                                          masterclassData?.coachVaultStartDate
                                        )
                                        ?.format("MMM DD")}
                                    </Typography>
                                  )}
                              </Box>
                            </Box>
                            {/* FIX: Wrap the progress/lock icon in a consistent container */}
                            <Box
                              mr={1}
                              display="flex"
                              alignItems="center"
                              gap={1}
                              minWidth="40px" // ADD THIS to ensure consistent width
                              justifyContent="center" // ADD THIS for centering
                            >
                              {sectionType !== "Overview" ? (
                                sectionType === "CoachesVault" &&
                                masterclassData?.trainings?.[
                                  "CoachesVault"
                                ]?.filter((training) => training?.isUnlocked)
                                  ?.length <= 0 ? (
                                  <LockIcon />
                                ) : (
                                  <CircularProgressStatic
                                    levelName={sectionType}
                                    selected={selectedLevel === sectionType}
                                    percentage={
                                      masterclassData?.percentages?.[
                                        sectionType
                                      ]
                                    }
                                  />
                                )
                              ) : null}
                            </Box>
                          </Box>
                          {sectionType === "CoachesVault" &&
                          masterclassData?.trainings?.["CoachesVault"]?.filter(
                            (training) => training?.isUnlocked
                          )?.length <= 0 ? (
                            <></>
                          ) : (
                            trainings.length > 0 &&
                            sectionType !== "Overview" && (
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleLevelExpansion(sectionType);
                                }}
                                sx={{ color: "#FCFCFC", p: 0.5, mt: 2 }}
                              >
                                {expandedLevels[sectionType] ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </IconButton>
                            )
                          )}
                        </Box>
                      </Button>

                      {/* Training list for masterclass sections */}
                      {expandedLevels[sectionType] && trainings.length > 0 && (
                        <Box
                          sx={{
                            mt: 2,
                            backgroundColor: "rgba(255, 255, 255, 0.05)",
                            borderRadius: "8px"
                          }}
                        >
                          {trainings.map((training) => (
                            <Box
                              key={training.trainingId}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "8px 12px",
                                borderBottom:
                                  "1px solid rgba(255, 255, 255, 0.1)",
                                "&:last-child": {
                                  borderBottom: "none"
                                }
                              }}
                            >
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                  sx={{
                                    color: "#FCFCFC",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    fontStyle: "italic"
                                  }}
                                >
                                  <strong style={{ color: "#64AEDD" }}>
                                    {training.day}
                                  </strong>{" "}
                                  {training.title}
                                </Typography>
                              </Box>
                              {training.isUnlocked && (
                                <IconButton
                                  sx={{
                                    padding: "0 !important",
                                    cursor: "pointer"
                                  }}
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    dispatch(
                                      updateMasterclassTrainingById({
                                        id: training.trainingId,
                                        updates: {
                                          isFavorite: !training.isFavorite
                                        }
                                      })
                                    );
                                    await updateMasterclassTrainingProgress({
                                      trainingId: training.trainingId,
                                      isFavorite: !training.isFavorite
                                    });
                                  }}
                                >
                                  {training?.isFavorite ? (
                                    <Bookmark
                                      sx={{
                                        height: "18px",
                                        width: "18px",
                                        fill: "#03B55C"
                                      }}
                                    />
                                  ) : (
                                    <BookmarkBorder
                                      sx={{
                                        height: "18px",
                                        width: "18px",
                                        fill: styles.color
                                      }}
                                    />
                                  )}
                                </IconButton>
                              )}
                              <Box
                                sx={{
                                  ml: 1,
                                  display: "flex",
                                  alignItems: "center"
                                }}
                                onClick={() => {
                                  if (!training.isUnlocked) return;
                                  const dayNumber =
                                    +training.day?.split(" ")[1];
                                  setActiveDay(dayNumber);
                                  setTocDay(dayNumber);
                                  const pageIndex = Math.floor(
                                    (dayNumber - 1) / visibleDaysCount
                                  );
                                  const calculatedStartDay =
                                    pageIndex * visibleDaysCount + 1;
                                  setStartDay(calculatedStartDay);
                                  setSelectedLevel(sectionType);
                                  setActiveLevelForMobile(true);
                                }}
                              >
                                {training.isUnlocked ? (
                                  <PlayCircleFilled
                                    sx={{
                                      color: "#64AEDD",
                                      fontSize: 20,
                                      ":hover": {
                                        cursor: "pointer"
                                      }
                                    }}
                                  />
                                ) : (
                                  <Lock
                                    sx={{
                                      color: "#9E9E9E",
                                      fontSize: 20,
                                      ":hover": {
                                        cursor: "not-allowed"
                                      }
                                    }}
                                  />
                                )}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                  )
                )}
              {allLevels?.map(
                ({
                  title,
                  trainingCompletionPercentage,
                  levelName,
                  totalTrainingDays,
                  levelActive,
                  description
                }) => (
                  <Box key={levelName} sx={{ width: "100%" }}>
                    <Button
                      fullWidth
                      onClick={async (e) => {
                        if (showMasterclass && !levelActive) return;
                        // Your existing onClick logic remains exactly the same
                        if (levelActive) handleLevelSelect(levelName);
                        if (
                          !levelActive ||
                          (!userData?.isTrainingFreeTrialExpired &&
                            userData?.isSubscriptionNeeded)
                        ) {
                          const levelId = allLevels?.find(
                            (item) => item?.levelName === levelName
                          )?.levelId;
                          if (
                            userData?.levelId?.toString() !==
                            levelId?.toString()
                          ) {
                            setSnackbarMessage(
                              userData?.userType === "Coach" &&
                                !userData?.purchased_training_by_admin?.includes(
                                  levelName
                                ) &&
                                !userData?.isAdmin
                                ? `Please contact your coach to unlock the full training`
                                : `Please complete all prior trainings in order to ${
                                    userData?.isAdmin ||
                                    userData?.userType === "Coach" ||
                                    userData?.purchased_training_by_admin?.includes(
                                      levelName
                                    ) ||
                                    userData?.bundleUserAmount ||
                                    ([
                                      "Gym",
                                      "Individual",
                                      "Affiliate"
                                    ].includes(userData?.userType) &&
                                      !userData?.isAdmin &&
                                      (userData?.isNewPlanUser ||
                                        (!userData?.isNewPlanUser
                                          ? !userData?.isSubscriptionActive
                                          : false)))
                                      ? "begin"
                                      : "purchase"
                                  }`
                            );
                            setOpenSnackbar(true);
                            return;
                          }
                          if (
                            ["Gym", "Affiliate", "Individual"]?.includes(
                              userData?.userType
                            ) &&
                            !userData?.isAdmin &&
                            !userData?.isSubscriptionActive
                            //  &&
                            // levelName === "level1"
                          ) {
                            setOpenModal(true);
                            return;
                          }
                          if (userData?.userType !== "Coach") {
                            const data = await purchaseTraining(levelId);
                            window.location.href = data?.sessionUrl;
                          }
                        }
                      }}
                      sx={{
                        ...(levelActive && {
                          paddingBottom: "0 !important",
                          paddingTop: "36px !important"
                        }),
                        // Your existing sx styles remain exactly the same
                        padding:
                          ["Gym", "Individual", "Affiliate"].includes(
                            userData?.userType
                          ) &&
                          !userData?.isAdmin &&
                          (userData?.isNewPlanUser ||
                            (!userData?.isNewPlanUser
                              ? !userData?.isSubscriptionActive
                              : false))
                            ? "45px 24px"
                            : !(
                                userData?.isAdmin !== 1 &&
                                userData?.userType !== "Company" &&
                                !userData?.bundleUserAmount &&
                                !(
                                  userData?.userType === "Coach" ||
                                  userData?.purchased_training_by_admin?.includes(
                                    levelName
                                  )
                                ) &&
                                !userData?.isSuperAdmin &&
                                !userData?.isManuallyCharged &&
                                !(
                                  (levelActive &&
                                    !userData?.isSubscriptionNeeded) ||
                                  (trainingCompletionPercentage === 100 &&
                                    totalTrainingDays !== 0) ||
                                  userData?.couponData?.trainingAccess?.[
                                    levelName
                                  ]
                                )
                              )
                            ? isMobile
                              ? 3
                              : "45px 24px"
                            : 3,
                        alignItems: "center",
                        border:
                          selectedLevel === levelName
                            ? "1px solid #368AD0"
                            : "1px solid #D1D5DB",
                        borderRadius: "16px",
                        backgroundColor:
                          selectedLevel === levelName
                            ? "#368AD0"
                            : "transparent"
                      }}
                    >
                      <Box
                        width="100%"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        textTransform="none"
                      >
                        <Box
                          display="flex"
                          gap="16px"
                          justifyContent="space-between"
                          alignItems="center"
                          width="100%"
                        >
                          <Box
                            textAlign={"start"}
                            gap="4px"
                            display="flex"
                            flexDirection="column"
                          >
                            {/* ALL your existing content remains exactly the same */}
                            {levelName === "level1" &&
                              !userData?.isTrainingFreeTrialExpired &&
                              userData?.isSubscriptionNeeded && (
                                <Box
                                  textAlign="start"
                                  sx={{
                                    width: "110px",
                                    background: "#368AD0",
                                    padding: "2px 6px"
                                  }}
                                >
                                  <Typography
                                    fontSize="10px"
                                    textTransform="capitalize"
                                    fontWeight="bold"
                                    fontStyle="italic"
                                    color={"#333333"}
                                  >
                                    FIRST 5 DAYS FREE
                                  </Typography>
                                </Box>
                              )}
                            <Box>
                              <Typography
                                color={"#FCFCFC"}
                                fontSize="0.95rem"
                                fontWeight={600}
                              >
                                {title} <sup>&#174;</sup>
                              </Typography>
                            </Box>
                            {/* All your existing description and buy button logic stays the same */}
                            {["Gym", "Individual", "Affiliate"].includes(
                              userData?.userType
                            ) &&
                            !userData?.isAdmin &&
                            !showMasterclass &&
                            (userData?.isNewPlanUser ||
                              (!userData?.isNewPlanUser
                                ? !userData?.isSubscriptionActive
                                : false)) ? (
                              //     &&
                              // !levelActive
                              <></>
                            ) : showMasterclass &&
                              !(
                                userData?.userType === "Coach" &&
                                userData?.isAdmin
                              ) &&
                              !levelActive ? (
                              <Box>
                                <Typography
                                  color={
                                    selectedLevel === levelName
                                      ? "#FCFCFC"
                                      : "#D1D5DB"
                                  }
                                  fontSize="12px"
                                >
                                  {`Unlocks on ${dayjs
                                    .utc(
                                      showMasterclass?.[
                                        `${levelName}_start_date`
                                      ]
                                    )
                                    .format("MMM DD")}`}
                                </Typography>
                              </Box>
                            ) : description?.includes("$") ? (
                              userData?.isAdmin !== 1 &&
                              userData?.userType === "Coach" &&
                              !(
                                (levelActive &&
                                  !userData?.isSubscriptionNeeded) ||
                                (trainingCompletionPercentage === 100 &&
                                  totalTrainingDays !== 0) ||
                                userData?.couponData?.trainingAccess?.[
                                  levelName
                                ]
                              ) ? (
                                <Box>
                                  <Typography
                                    width={"100%"}
                                    color={
                                      selectedLevel === levelName
                                        ? "#FCFCFC"
                                        : "#D1D5DB"
                                    }
                                    fontSize="13px"
                                  >
                                    {levelName === "level1"
                                      ? description?.replace(
                                          /unlock for (\$(\d+(\.\d{1,2})?))/i,
                                          (_, fullMatch, amountStr) => {
                                            const amount =
                                              parseFloat(amountStr);
                                            const converted =
                                              currentCurrency?.rate * amount;
                                            const formatted = Number.isInteger(
                                              converted
                                            )
                                              ? converted
                                              : converted.toFixed(2);
                                            return !levelActive &&
                                              userData?.purchased_training_by_admin?.includes(
                                                levelName
                                              )
                                              ? `to begin`
                                              : `Coach unlocks ($${amount})`;
                                          }
                                        )
                                      : description?.replace(
                                          /and then unlock for (\$(\d+(\.\d{1,2})?))/i,
                                          (_, fullMatch, amountStr) => {
                                            const amount =
                                              parseFloat(amountStr);
                                            const converted =
                                              currentCurrency?.rate * amount;
                                            const formatted = Number.isInteger(
                                              converted
                                            )
                                              ? converted
                                              : converted.toFixed(2);
                                            return !levelActive &&
                                              userData?.purchased_training_by_admin?.includes(
                                                levelName
                                              )
                                              ? `to begin`
                                              : `and then Coach unlocks ($${amount})`;
                                          }
                                        )}
                                  </Typography>
                                </Box>
                              ) : userData?.isAdmin !== 1 &&
                                userData?.userType !== "Company" &&
                                !userData?.isManuallyCharged &&
                                !userData?.isSuperAdmin &&
                                !userData?.bundleUserAmount &&
                                !(
                                  (levelActive &&
                                    !userData?.isSubscriptionNeeded) ||
                                  (trainingCompletionPercentage === 100 &&
                                    totalTrainingDays !== 0) ||
                                  userData?.couponData?.trainingAccess?.[
                                    levelName
                                  ]
                                ) ? (
                                <Box>
                                  <Typography
                                    width={"100%"}
                                    color={
                                      selectedLevel === levelName
                                        ? "#FCFCFC"
                                        : "#D1D5DB"
                                    }
                                    fontSize="14px"
                                  >
                                    {!levelActive &&
                                    userData?.purchased_training_by_admin?.includes(
                                      levelName
                                    )
                                      ? description?.replace(
                                          /and then unlock for (\$(\d+(\.\d{1,2})?))/i,
                                          "to begin"
                                        )
                                      : description?.replace(
                                          /\$\d+(\.\d{1,2})?/,
                                          (match) => {
                                            const value = parseFloat(
                                              match.slice(1)
                                            );
                                            const converted =
                                              currentCurrency?.rate * value;
                                            return `${currentCurrency?.symbol}${
                                              Number.isInteger(converted)
                                                ? converted
                                                : converted.toFixed(2)
                                            }`;
                                          }
                                        )}
                                  </Typography>
                                </Box>
                              ) : (
                                <></>
                              )
                            ) : (
                              <Box>
                                <Typography
                                  width={"80%"}
                                  color={
                                    selectedLevel === levelName
                                      ? "#FCFCFC"
                                      : "#D1D5DB"
                                  }
                                  fontSize="14px"
                                >
                                  {description}
                                </Typography>
                              </Box>
                            )}
                            {/* Your existing Buy Now button logic stays the same */}
                            {["Gym", "Individual", "Affiliate"].includes(
                              userData?.userType
                            ) &&
                            !userData?.isAdmin &&
                            (userData?.isNewPlanUser ||
                              (!userData?.isNewPlanUser
                                ? !userData?.isSubscriptionActive
                                : false)) ? (
                              //     &&
                              // !levelActive
                              <></>
                            ) : userData?.isAdmin !== 1 &&
                              userData?.userType !== "Company" &&
                              !(
                                userData?.userType === "Coach" ||
                                userData?.purchased_training_by_admin?.includes(
                                  levelName
                                )
                              ) &&
                              !userData?.isSuperAdmin &&
                              !userData?.bundleUserAmount &&
                              !userData?.isManuallyCharged &&
                              !(
                                (levelActive &&
                                  !userData?.isSubscriptionNeeded) ||
                                (trainingCompletionPercentage === 100 &&
                                  totalTrainingDays !== 0) ||
                                userData?.couponData?.trainingAccess?.[
                                  levelName
                                ]
                              ) ? (
                              <>
                                <Button
                                  sx={{
                                    mt: 1,
                                    width: 89,
                                    height: "23px",
                                    textTransform: "none",
                                    background:
                                      selectedLevel === levelName
                                        ? "#FCFCFC"
                                        : "#D1D5DB",
                                    color:
                                      selectedLevel === levelName
                                        ? "#64AEDD"
                                        : "black",
                                    gap: "10px"
                                  }}
                                >
                                  <Typography fontSize="12px" fontWeight={500}>
                                    Buy Now
                                  </Typography>
                                  <IconButton
                                    sx={{
                                      background:
                                        selectedLevel === levelName
                                          ? "#64AEDD"
                                          : "#14142B",
                                      borderRadius: "50%",
                                      padding: "1px"
                                    }}
                                  >
                                    <ChevronRight
                                      sx={{
                                        height: 12,
                                        width: 12,
                                        color: "#FCFCFC"
                                      }}
                                    />
                                  </IconButton>
                                </Button>
                              </>
                            ) : (
                              <></>
                            )}
                          </Box>
                          <Box
                            mr={1}
                            display="flex"
                            alignItems="center"
                            gap={1}
                          >
                            {/* Your existing progress/lock icon logic */}
                            {levelActive ? (
                              <CircularProgressStatic
                                levelName={levelName}
                                selected={selectedLevel === levelName}
                                percentage={trainingCompletionPercentage}
                              />
                            ) : !levelActive &&
                              userData?.purchased_training_by_admin?.includes(
                                levelName
                              ) ? (
                              <></>
                            ) : (
                              <LockIcon />
                            )}
                          </Box>
                        </Box>
                        {levelActive && (
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleLevelExpansion(levelName);
                            }}
                            sx={{ color: "#FCFCFC", p: 0.5, mt: 2 }}
                          >
                            {expandedLevels[levelName] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </IconButton>
                        )}
                      </Box>
                    </Button>

                    {/* NEW ADDITION: Training list - only show in mobile when expanded */}
                    {expandedLevels[levelName] && levelActive && (
                      <Box
                        sx={{
                          mt: 2,
                          // ml: 2,
                          // mr: 2,
                          backgroundColor: "rgba(255, 255, 255, 0.05)",
                          borderRadius: "8px"
                          // padding: "8px"
                        }}
                      >
                        {trainingWithTitleData
                          ?.find((item) => item.levelName === levelName)
                          ?.trainings?.map(
                            ({
                              trainingId,
                              day,
                              title,
                              isUnlocked,
                              isFavorite
                            }) => (
                              <Box
                                key={trainingId}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "8px 12px",
                                  borderBottom:
                                    "1px solid rgba(255, 255, 255, 0.1)",
                                  "&:last-child": {
                                    borderBottom: "none"
                                  }
                                }}
                              >
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography
                                    sx={{
                                      color: "#FCFCFC",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      fontStyle: "italic"
                                    }}
                                  >
                                    <strong style={{ color: "#64AEDD" }}>
                                      {" "}
                                      {day}
                                    </strong>{" "}
                                    {title}
                                  </Typography>
                                </Box>
                                <IconButton
                                  sx={{
                                    padding: "0 !important",
                                    cursor: !isUnlocked
                                      ? "not-allowed"
                                      : "pointer"
                                  }}
                                  onClick={async (e) => {
                                    if (!isUnlocked) return;
                                    e.stopPropagation();
                                    dispatch(
                                      updateTrainingById({
                                        id: trainingId,
                                        updates: {
                                          isFavorite: !isFavorite
                                        }
                                      })
                                    );

                                    dispatch(
                                      updateTrainingProgressById({
                                        id: trainingId,
                                        updates: {
                                          isFavorite: !isFavorite
                                        }
                                      })
                                    );

                                    await updateTrainingProgress({
                                      trainingId: trainingId,
                                      isFavorite: !isFavorite
                                    });
                                  }}
                                >
                                  {isFavorite ? (
                                    <Bookmark
                                      sx={{
                                        height: "18px",
                                        width: "18px",
                                        fill: "#03B55C"
                                      }}
                                    />
                                  ) : (
                                    <BookmarkBorder
                                      sx={{
                                        height: "18px",
                                        width: "18px",
                                        fill: styles.color
                                      }}
                                    />
                                  )}
                                </IconButton>
                                <Box
                                  sx={{
                                    ml: 1,
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                  onClick={() => {
                                    if (!isUnlocked) return;
                                    const dayNumber = +day?.split(" ")[1];
                                    setActiveDay(dayNumber);
                                    setTocDay(dayNumber);
                                    localStorage.setItem(
                                      "lastProgramVisitedLevel",
                                      JSON.stringify({
                                        level: levelName,
                                        activeDay: dayNumber
                                      })
                                    );
                                    const pageIndex = Math.floor(
                                      (dayNumber - 1) / visibleDaysCount
                                    );
                                    // Calculate startDay for that page
                                    const calculatedStartDay =
                                      pageIndex * visibleDaysCount + 1;
                                    setStartDay(calculatedStartDay);
                                    setSelectedLevel(levelName);
                                    setActiveLevelForMobile(true);
                                    window.scrollTo(0, 0);
                                    const scrollableElement =
                                      document.getElementById("dashboard-main");
                                    scrollableElement.scrollTo(0, 0);
                                  }}
                                >
                                  {isUnlocked ? (
                                    <PlayCircleFilled
                                      sx={{
                                        color: "#64AEDD",
                                        fontSize: 20,
                                        ":hover": {
                                          cursor: "pointer"
                                        }
                                      }}
                                    />
                                  ) : (
                                    <Lock
                                      sx={{
                                        color: "#9E9E9E",
                                        fontSize: 20,
                                        ":hover": {
                                          cursor: "not-allowed"
                                        }
                                      }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            )
                          )}
                      </Box>
                    )}
                  </Box>
                )
              )}
            </Box>
            <Snackbar
              open={openSnackbar}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              autoHideDuration={4000}
              onClose={() => setOpenSnackbar(false)}
            >
              <Alert
                onClose={() => setOpenSnackbar(false)}
                severity={
                  snackbarMessage.includes("Success") ? "success" : "error"
                }
                variant="filled"
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
            {!isMobile && selectedLevel && (
              <Box
                display="flex"
                sx={{
                  width: isLaptop
                    ? "100%"
                    : !isMobile
                    ? { md: open ? "68%" : "73%" }
                    : "100%",
                  padding: "0 25px"
                  // ...((!isTablet || !isMobile) && {
                  //   maxHeight: "calc(100vh - 40px)"
                  // })
                }}
                flexDirection="column"
                gap={3}
                ml={isMobile ? 0 : 2}
              >
                {/* {isContentLocked ? (
                  <Box
                    sx={{
                      background:
                        "radial-gradient(circle at 50% 50%, #368AD0, #2D5F87, #1A3A5C)",
                      width: "100%",
                      margin: "24px 16px",
                      height: "100%",
                      zIndex: 1,
                      borderRadius: "8px"
                    }}
                  >
                    <Box
                      display="flex"
                      borderRadius="8px"
                      justifyContent="center"
                      alignItems="center"
                      mr={1}
                      sx={{
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(8px)" // blur effect
                      }}
                    >
                      <LockIcon
                        style={{ color: "#FCFCFC", height: 70, width: 70 }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <> */}
                {selectedLevel === "Overview" ? (
                  <></>
                ) : (
                  <DaySelector
                    showReset={currentLevel?.completedTrainingDays > 0}
                    title={currentLevel?.title}
                    selectedLevel={selectedLevel}
                    activeData={currentActiveData}
                    onFavoriteClick={async () => {
                      if (selectedLevel?.includes("level")) {
                        dispatch(
                          updateTrainingById({
                            id: currentActiveData?.trainingId,
                            updates: {
                              isFavorite: !currentActiveData?.isFavorite
                            }
                          })
                        );
                        dispatch(
                          updateTrainingProgressById({
                            id: currentActiveData?.trainingId,
                            updates: {
                              isFavorite: !currentActiveData?.isFavorite
                            }
                          })
                        );
                        await updateTrainingProgress({
                          trainingId: currentActiveData?.trainingId,
                          isFavorite: !currentActiveData?.isFavorite
                        });
                      } else {
                        dispatch(
                          updateMasterclassTrainingById({
                            id: currentActiveData.trainingId,
                            updates: {
                              isFavorite: !currentActiveData.isFavorite
                            }
                          })
                        );
                        await updateMasterclassTrainingProgress({
                          trainingId: currentActiveData.trainingId,
                          isFavorite: !currentActiveData.isFavorite
                        });
                      }
                      localStorage.setItem(
                        "lastProgramVisitedLevel",
                        JSON.stringify({
                          level: selectedLevel,
                          activeDay: activeDay
                        })
                      );
                    }}
                    trainingWithTitleData={trainingWithTitleData?.find(
                      (level) => level.levelName === selectedLevel
                    )}
                    enabledDays={
                      // For masterclass, show all days; for regular training, use existing logic
                      showMasterclass &&
                      masterclassData?.trainings?.[selectedLevel]
                        ? currentTrainingData
                            ?.filter((item) => item?.isUnlocked)
                            ?.map((training) => +training.day?.split(" ")[1])
                        : currentLevel?.trainingCompletionPercentage === 100 &&
                          currentLevel?.totalTrainingDays !== 0
                        ? Array.from(
                            { length: currentLevel?.completedTrainingDays },
                            (_, i) => i + 1
                          )
                        : !userData?.isSubscriptionNeeded
                        ? Array.from(
                            {
                              length:
                                dayjs()
                                  .startOf("day")
                                  .diff(
                                    dayjs(
                                      dayjs(
                                        userData?.[
                                          `${currentLevel?.levelName}_start_date`
                                        ]
                                      )
                                        .utc()
                                        .format("YYYY-MM-DD")
                                    ).startOf("day"),
                                    "day"
                                  ) + 1
                            },
                            (_, i) => i + 1
                          )
                        : !userData?.isTrainingFreeTrialExpired
                        ? Array.from(
                            {
                              length: Math.min(
                                5,
                                dayjs()
                                  .startOf("day")
                                  .diff(
                                    dayjs(
                                      dayjs(
                                        userData?.[
                                          `${currentLevel?.levelName}_start_date`
                                        ]
                                      )
                                        .utc()
                                        .format("YYYY-MM-DD")
                                    ).startOf("day"),
                                    "day"
                                  ) + 1
                              )
                            },
                            (_, i) => i + 1
                          )
                        : []
                    }
                    refetchTrainingData={() => {
                      dispatch(
                        getCurrentUserLevels(dayjs().format("YYYY-MM-DD"))
                      );
                      if (currentLevel?.levelId)
                        dispatch(
                          getCurrentUserTrainings(currentLevel?.levelId)
                        );
                    }}
                    allCompletedData={allCompletedData}
                    activeDay={activeDay}
                    setActiveDay={setActiveDay}
                    startDay={startDay}
                    visibleDays={visibleDays}
                    visibleDaysCount={visibleDaysCount}
                    days={days}
                    setStartDay={setStartDay}
                    trainingData={trainingData}
                    handleDayClick={handleDayClick}
                    handleNext={handleNext}
                    handlePrevious={handlePrevious}
                  />
                )}

                {isContentLocked ? (
                  <Box
                    sx={{
                      background:
                        "radial-gradient(circle at 50% 50%, #368AD0, #2D5F87, #1A3A5C)",
                      width: "100%",
                      margin: "24px 16px",
                      height: "100vh",
                      zIndex: 1,
                      borderRadius: "8px"
                    }}
                  >
                    <Box
                      display="flex"
                      borderRadius="8px"
                      justifyContent="center"
                      alignItems="center"
                      mr={1}
                      sx={{
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(8px)" // blur effect
                      }}
                    >
                      <LockIcon
                        style={{
                          color: "#FCFCFC",
                          height: 70,
                          width: 70
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      ...((!isTablet || !isMobile) && {
                        overflowY: "auto",
                        ...(!Object.values(expandedLevels)?.filter(Boolean)
                          ?.length && {
                          maxHeight: "calc(100vh - 120px)"
                        }),
                        position: "relative"
                      })
                    }}
                  >
                    <RenderHtml
                      enabledDays={
                        // For masterclass, show all days; for regular training, use existing logic
                        showMasterclass &&
                        masterclassData?.trainings?.[selectedLevel]
                          ? currentTrainingData
                              ?.filter((item) => item?.isUnlocked)
                              ?.map((training) => +training.day?.split(" ")[1])
                          : currentLevel?.trainingCompletionPercentage ===
                              100 && currentLevel?.totalTrainingDays !== 0
                          ? Array.from(
                              { length: currentLevel?.completedTrainingDays },
                              (_, i) => i + 1
                            )
                          : !userData?.isSubscriptionNeeded
                          ? Array.from(
                              {
                                length:
                                  dayjs()
                                    .startOf("day")
                                    .diff(
                                      dayjs(
                                        dayjs(
                                          userData?.[
                                            `${currentLevel?.levelName}_start_date`
                                          ]
                                        )
                                          .utc()
                                          .format("YYYY-MM-DD")
                                      ).startOf("day"),
                                      "day"
                                    ) + 1
                              },
                              (_, i) => i + 1
                            )
                          : !userData?.isTrainingFreeTrialExpired
                          ? Array.from(
                              {
                                length: Math.min(
                                  5,
                                  dayjs()
                                    .startOf("day")
                                    .diff(
                                      dayjs(
                                        dayjs(
                                          userData?.[
                                            `${currentLevel?.levelName}_start_date`
                                          ]
                                        )
                                          .utc()
                                          .format("YYYY-MM-DD")
                                      ).startOf("day"),
                                      "day"
                                    ) + 1
                                )
                              },
                              (_, i) => i + 1
                            )
                          : []
                      }
                      key={`render-html-${activeDay}`}
                      isMobile={isMobile}
                      selectedLevel={selectedLevel}
                      setIsTrainingUpdated={setIsTrainingUpdated}
                      currentLevel={currentLevel}
                      activeLevelForMobile={activeLevelForMobile}
                      setIsAudioFinished={setIsAudioFinished}
                      isAudioFinished={isAudioFinished}
                      styles={styles}
                      activeDay={activeDay}
                      activeData={currentActiveData}
                      nextActiveData={nextActiveData}
                      setActiveDay={setActiveDay}
                      allLevels={allLevels}
                      setShowCompletionPopup={setShowCompletionPopup}
                      setCompletionPopupData={setCompletionPopupData}
                    />
                  </Box>
                )}
                {/* </>
                )} */}
              </Box>
            )}
          </Box>
        </Box>
      )}
      {activeLevelForMobile && isMobile && (
        <Box
          display="flex"
          sx={{
            width: "100%",
            padding: "10px 25px"
          }}
          flexDirection="column"
          gap={3}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <IconButton
              onClick={() => {
                setActiveLevelForMobile(false);
                setTocDay(0);
              }}
            >
              <ChevronLeft
                sx={{
                  width: 30,
                  height: 30,
                  color: styles.color
                }}
                width={30}
                height={30}
              />
            </IconButton>
            <MobileLevelsDropdown
              allLevels={allLevels}
              selectedLevel={selectedLevel}
              setSelectedLevel={setSelectedLevel}
              setActiveLevelForMobile={setActiveLevelForMobile}
              setActiveDay={setActiveDay}
              setStartDay={setStartDay}
              visibleDaysCount={visibleDaysCount}
              masterclassData={masterclassData}
              showMasterclass={showMasterclass}
              setSnackbarMessage={setSnackbarMessage}
              setOpenSnackbar={setOpenSnackbar}
              userData={userData}
            />
          </Box>
          {isContentLocked ? (
            <Box
              sx={{
                background:
                  "radial-gradient(circle at 50% 50%, #368AD0, #2D5F87, #1A3A5C)",
                width: "100%",
                margin: "24px 16px",
                height: "400px",
                zIndex: 1,
                borderRadius: "8px"
              }}
            >
              <Box
                display="flex"
                borderRadius="8px"
                justifyContent="center"
                alignItems="center"
                mr={1}
                sx={{
                  width: "100%",
                  height: "100%",
                  backdropFilter: "blur(8px)" // blur effect
                }}
              >
                <LockIcon style={{ color: "#FCFCFC", height: 70, width: 70 }} />
              </Box>
            </Box>
          ) : (
            <>
              {selectedLevel === "Overview" ? (
                <></>
              ) : (
                <DaySelector
                  showReset={currentLevel?.completedTrainingDays > 0}
                  title={currentLevel?.title}
                  selectedLevel={selectedLevel}
                  activeData={currentActiveData}
                  onFavoriteClick={async () => {
                    if (selectedLevel?.includes("level")) {
                      dispatch(
                        updateTrainingById({
                          id: currentActiveData?.trainingId,
                          updates: {
                            isFavorite: !currentActiveData?.isFavorite
                          }
                        })
                      );
                      dispatch(
                        updateTrainingProgressById({
                          id: currentActiveData?.trainingId,
                          updates: {
                            isFavorite: !currentActiveData?.isFavorite
                          }
                        })
                      );
                      await updateTrainingProgress({
                        trainingId: currentActiveData?.trainingId,
                        isFavorite: !currentActiveData?.isFavorite
                      });
                    } else {
                      dispatch(
                        updateMasterclassTrainingById({
                          id: currentActiveData.trainingId,
                          updates: {
                            isFavorite: !currentActiveData.isFavorite
                          }
                        })
                      );
                      await updateMasterclassTrainingProgress({
                        trainingId: currentActiveData.trainingId,
                        isFavorite: !currentActiveData.isFavorite
                      });
                    }
                    localStorage.setItem(
                      "lastProgramVisitedLevel",
                      JSON.stringify({
                        level: selectedLevel,
                        activeDay: activeDay
                      })
                    );
                  }}
                  trainingWithTitleData={trainingWithTitleData?.find(
                    (level) => level.levelName === selectedLevel
                  )}
                  refetchTrainingData={() => {
                    dispatch(
                      getCurrentUserLevels(dayjs().format("YYYY-MM-DD"))
                    );
                    if (currentLevel?.levelId)
                      dispatch(getCurrentUserTrainings(currentLevel?.levelId));
                  }}
                  enabledDays={
                    // For masterclass, show all days; for regular training, use existing logic
                    showMasterclass &&
                    masterclassData?.trainings?.[selectedLevel]
                      ? currentTrainingData
                          ?.filter((item) => item?.isUnlocked)
                          ?.map((training) => +training.day?.split(" ")[1])
                      : currentLevel?.trainingCompletionPercentage === 100 &&
                        currentLevel?.totalTrainingDays !== 0
                      ? Array.from(
                          { length: currentLevel?.completedTrainingDays },
                          (_, i) => i + 1
                        )
                      : !userData?.isSubscriptionNeeded
                      ? Array.from(
                          {
                            length:
                              dayjs()
                                .startOf("day")
                                .diff(
                                  dayjs(
                                    dayjs(
                                      userData?.[
                                        `${currentLevel?.levelName}_start_date`
                                      ]
                                    )
                                      .utc()
                                      .format("YYYY-MM-DD")
                                  ).startOf("day"),
                                  "day"
                                ) + 1
                          },
                          (_, i) => i + 1
                        )
                      : !userData?.isTrainingFreeTrialExpired
                      ? Array.from(
                          {
                            length: Math.min(
                              5,
                              dayjs()
                                .startOf("day")
                                .diff(
                                  dayjs(
                                    dayjs(
                                      userData?.[
                                        `${currentLevel?.levelName}_start_date`
                                      ]
                                    )
                                      .utc()
                                      .format("YYYY-MM-DD")
                                  ).startOf("day"),
                                  "day"
                                ) + 1
                            )
                          },
                          (_, i) => i + 1
                        )
                      : []
                  }
                  allCompletedData={allCompletedData}
                  activeDay={activeDay}
                  setActiveDay={setActiveDay}
                  startDay={startDay}
                  visibleDays={visibleDays}
                  visibleDaysCount={visibleDaysCount}
                  days={days}
                  setStartDay={setStartDay}
                  trainingData={trainingData}
                  handleDayClick={handleDayClick}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                />
              )}
              <Box>
                <RenderHtml
                  enabledDays={
                    // For masterclass, show all days; for regular training, use existing logic
                    showMasterclass &&
                    masterclassData?.trainings?.[selectedLevel]
                      ? currentTrainingData
                          ?.filter((item) => item?.isUnlocked)
                          ?.map((training) => +training.day?.split(" ")[1])
                      : currentLevel?.trainingCompletionPercentage === 100 &&
                        currentLevel?.totalTrainingDays !== 0
                      ? Array.from(
                          { length: currentLevel?.completedTrainingDays },
                          (_, i) => i + 1
                        )
                      : !userData?.isSubscriptionNeeded
                      ? Array.from(
                          {
                            length:
                              dayjs()
                                .startOf("day")
                                .diff(
                                  dayjs(
                                    dayjs(
                                      userData?.[
                                        `${currentLevel?.levelName}_start_date`
                                      ]
                                    )
                                      .utc()
                                      .format("YYYY-MM-DD")
                                  ).startOf("day"),
                                  "day"
                                ) + 1
                          },
                          (_, i) => i + 1
                        )
                      : !userData?.isTrainingFreeTrialExpired
                      ? Array.from(
                          {
                            length: Math.min(
                              5,
                              dayjs()
                                .startOf("day")
                                .diff(
                                  dayjs(
                                    dayjs(
                                      userData?.[
                                        `${currentLevel?.levelName}_start_date`
                                      ]
                                    )
                                      .utc()
                                      .format("YYYY-MM-DD")
                                  ).startOf("day"),
                                  "day"
                                ) + 1
                            )
                          },
                          (_, i) => i + 1
                        )
                      : []
                  }
                  key={`render-html-${activeDay}`}
                  isMobile={isMobile}
                  selectedLevel={selectedLevel}
                  currentLevel={currentLevel}
                  setIsTrainingUpdated={setIsTrainingUpdated}
                  activeLevelForMobile={activeLevelForMobile}
                  setIsAudioFinished={setIsAudioFinished}
                  isAudioFinished={isAudioFinished}
                  styles={styles}
                  activeDay={activeDay}
                  setActiveDay={setActiveDay}
                  activeData={currentActiveData}
                  nextActiveData={nextActiveData}
                  allLevels={allLevels}
                  setShowCompletionPopup={setShowCompletionPopup}
                  setCompletionPopupData={setCompletionPopupData}
                />
              </Box>{" "}
            </>
          )}
        </Box>
      )}
      {(isMobile ? selectedLevel && activeLevelForMobile : selectedLevel) &&
        !isContentLocked &&
        link && (
          <Box
            sx={{
              position: "fixed",
              bottom: { xs: 95, sm: 20, md: 20 },
              right: 16,
              zIndex: 1000
            }}
          >
            <IconButton
              variant="contained"
              sx={{
                display: "flex",
                backgroundColor: "#FF4000",
                borderRadius: "24px",
                color: "#FCFCFC",
                padding: "7px 12px",
                fontSize: "16px",
                textTransform: "none",
                gap: "10px",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#FF7043"
                }
              }}
              onClick={() => {
                const url = link.startsWith("http") ? link : `http://${link}`;
                window.open(url, "_blank");
              }}
            >
              <QuestionAnswer />
              {/* <Typography
                sx={{
                  background: "#FCFCFC",
                  color: "#506DF0",
                  borderRadius: "50%",
                  padding: "7px 12px"
                }}
              >
                C
              </Typography>
              <Typography color="#FCFCFC">Join Us</Typography> */}
            </IconButton>
          </Box>
        )}

      {/* Completion Popup Dialog */}
      <Dialog
        open={showCompletionPopup}
        onClose={() => setShowCompletionPopup(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "24px 20px",
            maxWidth: "400px",
            margin: "16px",
            background: styles.background,
            color: styles.color
          }
        }}
      >
        <DialogContent sx={{ padding: 0, textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              color: styles.color,
              marginBottom: "16px"
            }}
          >
            Congratulations!
          </Typography>
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 400,
              color: styles.modLabel,
              lineHeight: "1.5"
            }}
          >
            {completionPopupData?.nextLevel ? (
              <>
                You have completed{" "}
                <strong style={{ color: styles.color }}>
                  {completionPopupData?.trainingName || "training"}
                </strong>
                . <br />
                {isMobile || isTablet
                  ? 'Use the dropdown menu at the top of the screen to start another program or click "Get Started".'
                  : 'Use the left side menu to start another program or click "Get Started".'}
              </>
            ) : (
              <>
                You have completed the{" "}
                <strong style={{ color: styles.color }}>
                  {completionPopupData?.trainingName || "training"}
                </strong>
                . You may refer back to these lessons at any time, Favorite your
                most helpful trainings
                {completionPopupData?.nextLevel?.levelId
                  ? ", and even Reset your progress to start a specific level again."
                  : "."}
              </>
            )}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "24px 0 0 0",
            flexDirection: "column",
            gap: "12px"
          }}
        >
          {completionPopupData?.nextLevel ? (
            <>
              <Button
                onClick={() => {
                  const updatedLevel = completionPopupData?.nextLevel;
                  const nextLevel =
                    allLevels?.find(
                      (level) => level.levelId === updatedLevel?.levelId
                    ) ||
                    updatedLevel ||
                    null;
                  if (nextLevel && nextLevel.levelActive) {
                    setSelectedLevel(nextLevel.levelName);
                    dispatch(updateSelectedLevel(nextLevel.levelName));
                    localStorage.setItem(
                      "lastProgramVisitedLevel",
                      JSON.stringify({
                        level: nextLevel.levelName,
                        activeDay: 1
                      })
                    );
                    setActiveDay(1);
                    setStartDay(1);
                    setActiveLevelForMobile(true);

                    // Refetch data for the new level
                    dispatch(fetchCurrentUser(dayjs().format("YYYY-MM-DD")));

                    // Check if it's a masterclass level or regular level
                    const isMasterclassLevel = [
                      "Overview",
                      "10Principles",
                      "CoachesVault"
                    ].includes(nextLevel.levelName);

                    if (isMasterclassLevel) {
                      // Dispatch masterclass trainings for masterclass sections
                      dispatch(
                        getCurrentUserMasterclassTrainings(
                          dayjs().format("YYYY-MM-DD")
                        )
                      );
                    } else if (nextLevel.levelId) {
                      // Dispatch regular trainings for regular levels
                      dispatch(getCurrentUserTrainings(nextLevel.levelId));
                    }
                  }
                  setShowCompletionPopup(false);
                }}
                sx={{
                  width: "100%",
                  backgroundColor: "#368AD0",
                  color: "#FFFFFF",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  padding: "8px 15px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#2a6ba4"
                  }
                }}
              >
                Get Started
              </Button>
              <Button
                onClick={() => setShowCompletionPopup(false)}
                sx={{
                  ml: `0 !important`,
                  width: "100%",
                  backgroundColor: "transparent",
                  color: "#368AD0",
                  fontSize: "16px",
                  fontWeight: 600,
                  textTransform: "none",
                  padding: "8px 15px",
                  borderRadius: "8px",
                  border: "1px solid #368AD0",
                  "&:hover": {
                    backgroundColor: "rgba(54, 138, 208, 0.04)",
                    border: "1px solid #368AD0"
                  }
                }}
              >
                Stay Here
              </Button>
            </>
          ) : (
            <Button
              onClick={() => setShowCompletionPopup(false)}
              sx={{
                width: "100%",
                backgroundColor: "#368AD0",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                padding: "8px 15px",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#2a6ba4"
                }
              }}
            >
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Programs;
